import React, { useContext, useEffect } from 'react';
import { TemplateContext } from '../../layout';
import Header from '../header';
import ProductsList from '../productsList';
import Message from '../message';
import TestimonialSlider from '../testimonials';
import BenefitsList from '../benefitsList';
import OrderSummary from '../orderSummary';
import Hero from '../hero';
import WarrantyCheckbox from '../warrantyCheckbox';
import OutsideClick from '../outsideClick';
import WarrantyPopup from '../warrantyPopup';
import Form from '../forms/form';

const FullWidthProducts = ({ base, containerClass, products, compliance }) => {
	const [templateContext] = useContext(TemplateContext);
	const showPopup = templateContext?.showPopup && templateContext?.displayPopup;

	return (
		<>
			<Header {...base?.checkout_v3_header} />
			<Hero {...base?.checkout_v3_hero} />
			<main className="main">
				<section className={containerClass}>
					<article className="productContainer">
						{!templateContext.outOfStockMode && <Message />}
						<ProductsList
							products={products}
							layoutOption="full"
							style={{
								marginBottom: templateContext?.displayWarrantyCheckbox == false ? '-12px' : 0,
							}}
						>
							{templateContext?.config?.isWarrantySelected && (
								<section className="warrantyContainer">
									{showPopup && (
										<OutsideClick>
											<WarrantyPopup
												data={base?.checkout_v3_warranty}
												showPopup={templateContext.showPopup}
											/>
										</OutsideClick>
									)}
									{!templateContext.outOfStockMode && (
										<WarrantyCheckbox
											data={base?.checkout_v3_warranty}
											handleClick={() => toggleWarrantyCheckbox()}
											value={templateContext.config?.warrantyState}
										/>
									)}
								</section>
							)}
						</ProductsList>
						{!compliance && <TestimonialSlider data={base?.checkout_v3_testimonials} displayOnMobile={false} />}
					</article>
					<article className="formContainer" data-outofstock={templateContext.outOfStockMode}>
						<Form />
						{!templateContext.outOfStockMode && <OrderSummary />}
					</article>
				</section>
				<section className="bottomContainer">
					{!compliance && <TestimonialSlider data={base?.checkout_v3_testimonials} displayOnMobile={true} />}
					<BenefitsList data={base?.checkout_v3_benefits} fullWidth="full" />
					<BenefitsList data={base?.checkout_v3_benefits} fullWidth="full" displayOnMobile={true} />
				</section>
			</main>
		</>
	);
};

export default FullWidthProducts;
